import { Button } from "antd";
import UserActivityStatus from "../../components/user-activity-status/user-activity-status";
import getDateByDiff from "../../common/utils/calendar/get-date-by-diff";
import ApiSubjectsManagement from "../../api/subjects-manager";
import "./sidebar-subject-info.css";
import { useNotification } from "../notification/notification";
import { useTranslation } from "react-i18next";
import { useCan } from "../../common/utils/usePermissions";

const SidebarSubjectInfo = ({
  firstName,
  lastName,
  lastActivity,
  status,
  personStatus,
  personId,
  subjectId,
  onUnblocked,
}) => {
  const { openNotification } = useNotification();
  const { t } = useTranslation();
  const isPersonBlocked = personStatus === "blocked";
  // LF360-2024: the server unblocks only with `subjects.unblock`.
  const canUnblock = useCan("subjects.unblock");

  const handleUnblock = async () => {
    try {
      await ApiSubjectsManagement.unblockPerson(subjectId);

      openNotification({
        type: "success",
        message: (
          <p>
            {t("subject_management.notification.unblocked")}
          </p>
        ),
      });

      if (onUnblocked) onUnblocked();
    } catch (e) {
      openNotification({
        type: "error",
        message: (
          <p>
            {t("subject_management.notification.unblock_failed")}
          </p>
        ),
      });
    }
  };

  return (
    <div className="sidebar-subject-info-wrapper">
      <div className="sidebar-subject-info">
        <div>
          <div className="sidebar-subject-info__name">
            {firstName} {lastName}
          </div>
          <div className="sidebar-subject-info__last-activity">
            Last activity {getDateByDiff(lastActivity)}
          </div>
        </div>

        <div className="lf-status-stack">
          <UserActivityStatus userStatus={status} />
          {isPersonBlocked && (
            <UserActivityStatus userStatus="blocked" secondary />
          )}
        </div>
      </div>

      {isPersonBlocked && canUnblock && (
        <Button
          size="large"
          block
          className="sidebar-subject-info__unblock"
          onClick={handleUnblock}
        >
          Unblock subject
        </Button>
      )}
    </div>
  );
};

export default SidebarSubjectInfo;

